<template>
  <v-container fluid>
    <v-row class="mb-n6">
      <v-col>
        <p>ລາຍງານເຄື່ອນໄຫວລູກຄ້າສາຍບ້ານ</p>
      </v-col>
    </v-row>

    <v-card class="mt-6">
      <v-card-title>
        <v-row>
          <v-col
            cols="6"
            md="2"
          >
            <v-text-field
              v-model="dateFrom"
              type="date"
              label="ອະນຸມັດແຕ່ວັນທີ"
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col
            cols="6"
            md="2"
          >
            <v-text-field
              v-model="dateTo"
              type="date"
              label="ຫາວັນທີ"
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-select
              v-model="kind"
              :items="kinds"
              label="ປະເພດ"
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col
            cols="6"
            md="2"
          >
            <!-- The dates and the kind apply only when this is pressed. -->
            <v-btn
              color="primary"
              block
              :loading="loading"
              @click="fetchData()"
            >
              <v-icon left>
                mdi-magnify
              </v-icon>
              ຄົ້ນຫາ
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            md="3"
          >
            <v-btn
              color="success"
              block
              :loading="exporting"
              :disabled="exporting || !rows.length"
              @click="exportExcel()"
            >
              <v-icon left>
                mdi-microsoft-excel
              </v-icon>
              Export Excel
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-subtitle class="pt-2">
        ທັງໝົດ {{ rows.length }} ລາຍການ
        <span
          v-for="k in kindList"
          :key="k.value"
          class="ml-4"
        >{{ k.text }} {{ count(k.value) }}</span>
      </v-card-subtitle>
      <v-data-table
        :headers="headers"
        :items="rows"
        item-key="key"
        :loading="loading"
        :items-per-page="50"
        dense
        class="activity-table"
        no-data-text="ບໍ່ມີການເຄື່ອນໄຫວໃນຊ່ວງນີ້"
      >
        <template v-slot:[`item.kind_label`]="{ item }">
          <v-chip
            x-small
            label
            :color="kindColor(item.kind)"
            dark
          >
            {{ item.kind_label }}
          </v-chip>
        </template>
        <template v-slot:[`item.customer_name`]="{ item }">
          <div>{{ item.customer_name }}</div>
          <div class="text-caption grey--text">
            {{ item.customer_code }} · {{ item.phone }}
          </div>
        </template>
        <template v-slot:[`item.detail`]="{ item }">
          <div class="wrap-cell">
            {{ item.detail }}
          </div>
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          {{ money(item.amount) }}
        </template>
        <template v-slot:[`item.reason`]="{ item }">
          <div class="wrap-cell">
            {{ item.reason }}
          </div>
        </template>
        <template v-slot:[`item.current_status`]="{ item }">
          <span :class="item.current_status === 'ລຶບແລ້ວ' ? 'red--text' : ''">{{ item.current_status }}</span>
          <div class="text-caption">
            {{ item.current_collect }}
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { today } from '@/Helpers/localDate';

const KINDS = [
  { value: 'delete_customer', text: 'ລຶບລູກຄ້າ', color: 'red darken-1' },
  { value: 'delete_bill', text: 'ລຶບບິນ', color: 'orange darken-2' },
  { value: 'status', text: 'ປິດ/ເປີດສາຍບ້ານ', color: 'blue darken-1' },
  { value: 'convert', text: 'ປິດສາຍບ້ານເປີດທຸລະກິດ', color: 'teal darken-1' },
];

export default {
  name: 'HomeActivityReport',
  title() {
    return 'Vientiane Waste Co-Dev|Home Activity Report';
  },
  data() {
    return {
      // Opens on today, like the other activity pages.
      dateFrom: today(),
      dateTo: today(),
      kind: 'all',
      applied: {},
      rows: [],
      loading: false,
      exporting: false,
      kindList: KINDS,
      // Vuetify does not show a selected null value, so "all" is a real value.
      kinds: [{ value: 'all', text: 'ທັງໝົດ' }, ...KINDS.map(({ value, text }) => ({ value, text }))],
      headers: [
        { text: 'ລຳດັບ', value: 'no' },
        { text: 'ວັນທີອະນຸມັດ', value: 'date' },
        { text: 'ປະເພດ', value: 'kind_label' },
        { text: 'ລູກຄ້າ', value: 'customer_name' },
        { text: 'ບ້ານ', value: 'village' },
        { text: 'ເມືອງ', value: 'district' },
        { text: 'ແພັກເກດ', value: 'package' },
        { text: 'ລາຍລະອຽດ', value: 'detail', sortable: false },
        { text: 'ຍອດເງິນ', value: 'amount', align: 'end' },
        { text: 'ເຫດຜົນ', value: 'reason', sortable: false },
        { text: 'ຜູ້ສົ່ງ', value: 'submitter' },
        { text: 'ຜູ້ອະນຸມັດ', value: 'approvers', sortable: false },
        { text: 'ການນຳເຂົ້າຂໍ້ມູນ', value: 'source' },
        { text: 'ສະຖານະປັດຈຸບັນ', value: 'current_status' },
      ],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      // The export follows what the table shows, not values changed since the last search.
      this.applied = {
        date_from: this.dateFrom || undefined,
        date_to: this.dateTo || undefined,
        kind: this.kind === 'all' ? undefined : this.kind,
      };
      this.loading = true;
      this.$axios
        .get('report-home-activity', { params: this.applied })
        .then((res) => {
          this.rows = res.data.data.data.map((row) => ({ ...row, key: `${row.kind}-${row.source_id}` }));
        })
        .catch((error) => this.toastError(error))
        .finally(() => {
          this.loading = false;
        });
    },
    exportExcel() {
      this.exporting = true;
      this.$axios
        .get('report-home-activity/export', { params: this.applied, responseType: 'blob' })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = `ລາຍງານເຄື່ອນໄຫວລູກຄ້າສາຍບ້ານ_${this.applied.date_from || ''}_${this.applied.date_to || ''}.xlsx`;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => this.toastError(error))
        .finally(() => {
          this.exporting = false;
        });
    },
    count(kind) {
      return this.rows.filter((row) => row.kind === kind).length;
    },
    kindColor(kind) {
      return (KINDS.find((k) => k.value === kind) || {}).color || 'grey';
    },
    money(value) {
      return value === null || value === undefined ? '' : Number(value).toLocaleString();
    },
    toastError(error) {
      const data = (error.response && error.response.data) || {};
      this.$store.commit('Toast_State', { value: true, color: 'error', msg: data.message || 'Something went wrong' });
    },
  },
};
</script>

<style scoped>
.activity-table >>> th,
.activity-table >>> td {
  white-space: nowrap;
}
.wrap-cell {
  white-space: normal;
  min-width: 220px;
}
</style>
